<template>
    <div>
        <collapse :active-index="activeIndex" class="mt-4">
            <collapse-item
                class="card-color nch--card-shadow hover"
                :name="content.id"
                :locked="content.lock ? true : false"
                @onSelect.once="handleSelect"
                body-color="#ececec"
                :header-color="isSubmodule ? '#F7FAFC' : ''"
            >
                <template #title><div
                    class="d-flex justify-content-between align-items-center"
                    :class="checkType(content.lock)"
                    @click="showScheduleAlert"
                >
                    <h4 class="mb-0 ml false-3">{{ content.translation.name }}</h4>
                    <ContentLock
                        v-if="content.lock"
                        class="mx-3"
                        :message="content.lock_message"
                        :color="color.primary"
                        :icon="changeIcon"
                    />
                </div></template>
                <div class="module-container">
                    <div :style="{ color: color.primary }">
                        <span
                            @click.prevent.self="handleContentClick(true)"
                            v-if="content.forum"
                            :style="{ color: color.primary }"
                            class="forum"
                            :class="`mdi mdi-forum mdi-36px`"
                        ></span>
                    </div>
                    <ProgressBar
                        :style="{ width: '100%' }"
                        nocard
                        v-if="opened"
                        type="module"
                        :plan-id="plan"
                        :course-id="course.id"
                        :module-id="content.id"
                    />
                </div>
                <div v-for="(item, i) in contents" :key="i">
                    <div v-if="item.type === 'Module'">
                        <module-component
                            :ref="`submodule_${item.id}`"
                            :content="item"
                            :course-id="courseId"
                            :parent-id="nextParentId"
                            :submodules="nextSubmodules"
                            :public-user="publicUser"
                            :public-lesson-urls="publicLessonUrls"
                            bg-color="#F7FAFC"
                            is-submodule
                        ></module-component>
                    </div>
                    <component
                        v-else
                        :is="item.type"
                        class="nch--collapse-item"
                        :parent-id="nextParentId"
                        :submodules="nextSubmodules"
                        :content="item"
                        :course-id="courseId"
                        :module-id="content.id"
                        :public-user="publicUser"
                        :public-lesson-urls="publicLessonUrls"
                        bg-color="#F7FAFC"
                    ></component>
                </div>
                <loading-spinner
                    v-if="loading"
                    :color="color"
                ></loading-spinner>
                <div
                    v-else-if="!contents.length"
                    class="d-flex align-items-center justify-content-center"
                >
                    <span class="text-muted">
                        {{$t('course.module_no_content')}}
                    </span>
                </div>
                <base-button
                    v-else-if="contents.length < meta.total"
                    @click="onChangePage"
                    :style="$bgColor(color.primary)"
                    block
                    :loading="loading"
                >
                    {{ $t('course.show_more') }}
                </base-button>
            </collapse-item>
        </collapse>
        <Modal
            v-model:show="modal"
            size="lg"
            bodyClasses="forum-content-body p-0"
        >
            <Forum
                :name="content.translation.name"
                :forum="content.forum"
                modal
                @close="modal = false"
                @click="$event.preventDefault()"
            />
        </Modal>
    </div>
</template>

<script>
import LoadingSpinner from '../../Common/LoadingSpinner';
import ProgressBar from '../../Common/ProgressBar';

import ContentLock from '../../ContentComponents/ContentLock';
import Lesson from '../ContentComponents/LessonComponent';
import Exercise from '../ContentComponents/ExerciseComponent';
import Topic from '../ContentComponents/TopicComponent';
import Forum from '../../Forum';

import Collapse from '../../../argon/components/Collapse/Collapse';
import CollapseItem from '../../../argon/components/Collapse/CollapseItem';
import BaseButton from '../../../argon/components/BaseButton';
import Modal from '../../../argon/components/Modal';

export default {
    name: 'ModuleComponent',
    components: {
        Lesson,
        Exercise,
        LoadingSpinner,
        ProgressBar,
        Collapse,
        CollapseItem,
        BaseButton,
        ContentLock,
        Topic,
        Modal,
        Forum,
    },
    props: {
        content: {
            type: Object,
            required: true,
            description: 'Conteudo do tipo modulo',
        },
        courseId: {
            type: Number,
            required: true,
            description: 'Id do curso ao qual o modulo está vinculado',
        },
        parentId: {
            type: Number,
            required: false,
            description: 'Id do modulo pai',
        },
        isSubmodule: {
            type: Boolean,
            required: false,
            default: false,
            description: 'Indica se é um submodulo',
        },
        submodules: {
            type: Array,
            required: false,
            default: () => ([]),
            description: 'Lista com ids do submodulos anteriores',
        },
        index: {
            type: Number,
            description: 'Indice da lista de conteudos do curso ou modulo',
        },
        type: {
            type: String,
            description: 'Tipo de conteudo ex.: Modulo',
        },
        publicUser: {
            type: Boolean,
            default: false,
            description: 'Indica se o usuário é público',
        },
        publicLessonUrls: {
            type: Object,
            default: () => ({}),
            description: 'URLs assinadas para as lições',
        },
    },
    data() {
        return {
            contents: [],
            links: {},
            meta: {},
            loading: true,
            opened: false,
            activeIndex: -1,
            firstLoad: true,
            modal: false,
        };
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.contents.push(...value.data);
                this.links = value.links;
                this.meta = value.meta;
            },
        },
        formatedStartDate() {
            const startDate = new Date(this.content.module_publish.start_date);

            const formattedDate = startDate.toISOString().split('T')[0];

            const formattedTime = startDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedDateTimeWithSuffix = `${formattedDate} ${translation} ${formattedTime}`;

            return formattedDateTimeWithSuffix;
        },
        formatedEndDate() {
            const endDate = new Date(this.content.module_publish.end_date);

            const formattedEndDate = endDate.toISOString().split('T')[0];

            const formattedEndTime = endDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedEndDateTimeWithSuffix = `${formattedEndDate} ${translation} ${formattedEndTime}`;

            return formattedEndDateTimeWithSuffix;
        },
        scheduleContent() {
            if (this.content.lock_type === 'SCHEDULE') {
                if (this.content.module_publish && new Date(this.content.module_publish.start_date) > new Date() && this.content.module_publish.start_date != null) {
                    return `${this.$t('module.publish.schedule')} ${this.formatedStartDate} ${this.$t('common.and')} ${this.formatedEndDate}`;
                } else if (this.content.module_publish && new Date(this.content.module_publish.end_date) < new Date() && this.content.module_publish.end_date != null) {
                    return `${this.$t('module.publish.schedule_end')} ${this.formatedEndDate}`;
                }
            }

            if (this.content.module_publish.start_date === null && this.content.module_publish.end_date === null) {
                return this.$t('common.blocked');
            }
        },
        changeIcon() {
            if (this.content.lock_type === 'SCHEDULE') {
                const currentDate = new Date().toISOString().split('T')[0];

                if (this.content.module_publish.start_date > currentDate) {
                    return 'mdi mdi-calendar-clock';
                } else if (this.content.module_publish.end_date < currentDate) {
                    return 'mdi mdi-calendar-check';
                }
            } else {
                return 'mdi mdi-lock-outline';
            }
        },
        plan() {
            return this.$store.getters.PLAN;
        },
        course() {
            return this.$store.getters.COURSE;
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        color() {
            return this.$store.getters.COLOR;
        },
        nextSubmodules() {
            return this.isSubmodule ? [...this.submodules, this.content.id] : this.submodules;
        },
        nextParentId() {
            return this.isSubmodule ? this.parentId : this.content.id;
        },
    },
    methods: {
        showScheduleAlert() {
            if (this.content.lock_type === 'AVAILABLE') {

            } else if (this.content.lock_type === 'SCHEDULE') {
                return this.$notify({
                    type: 'warning',
                    message: this.scheduleContent,
                });
            } else {
                return this.$notify({
                    type: 'warning',
                    message: this.$t('common.blocked'),
                });
            }
        },
        checkType(type) {
            return type === true && 'lock';
        },
        handleContentClick() {
            this.modal = true;
        },
        handleSelect() {
            if (!this.content.lock) {
                this.getContent();
            }
        },
        getContent(changePage = false) {
            if (changePage) {
                this.firstLoad = true;
            }
            if (!this.firstLoad) return;

            this.opened = true;
            this.loading = true;

            const baseUrl = `/api/app/plan/${this.plan}/course/${this.course.id}/module`;
            const URI = this.isSubmodule
                ? `${baseUrl}/${this.parentId}/contents`
                : `${baseUrl}/${this.content.id}/contents`;

            window.axios
                .get(URI, {
                    params: {
                        page: this.meta.current_page || 1,
                        per_page: 5,
                        iso: this.language.iso,
                        submodules: this.nextSubmodules,
                    },
                })
                .then((res) => {
                    this.data = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onChangePage() {
            this.meta.current_page += 1;
            this.getContent(true);
        },
    },
    mounted() {
        if (this.index === 0 && this.type === 'Module') {
            this.activeIndex = 0;
            this.getContent();
            this.firstLoad = false;
        }
    },
};
</script>

<style scoped>
.forum {
    filter: grayscale(0);
    transition: all 0.2s ease-in;
    cursor: pointer;
}

.forum:hover {
    filter: grayscale(0.5);
}

.module-container {
    display: flex;
    align-content: space-between;
    align-items: baseline;
}

.hover .card-header:hover {
    background: #d8d8d8 !important;
}

.hover .card-header {
    transition: background 0.3s !important;
    border: none;
}

.nch--card-shadow {
    -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
        0 1px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.accordion > .card .card-header {
    background-color: #ececec;
    border-radius: 4px;
}
</style>
